import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import VideoPlayerPage from './VideoPlayerPage';

export const VideoPlayerModal = ({ isOpen, onClose, video, profile, allVideos }) => {
  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return createPortal(
    <div className="fixed inset-0 flex items-center justify-center overflow-hidden" style={{ zIndex: 99999 }}>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black/95 backdrop-blur-sm"
        style={{ zIndex: 99998 }}
        onClick={onClose}
      />

      {/* Modal Content */}
      <div className="relative w-full h-full overflow-y-auto overflow-x-hidden" style={{ zIndex: 99999 }}>
        <VideoPlayerPage
          video={video}
          profile={profile}
          allVideos={allVideos}
          onClose={onClose}
        />
      </div>
    </div>,
    document.body
  );
};

export default VideoPlayerModal;
